import React, { Component } from "react"
import styled from "styled-components"
import { ACTIVE_TEXT, TINY_SHADOW } from "./consts/colors.js"

export const TinyButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 25px 0px;
  width: 200px;
  padding: 10px 30px;
  border-radius: 50px;
  font-weight: 700;
  color: white;
  font-size: 17px;
  outline: none;
  border: 2px solid ${ACTIVE_TEXT};
  cursor: pointer;
  background: ${ACTIVE_TEXT};
  transition: all 200ms ease;
  :hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px ${TINY_SHADOW};
  }
  @media (max-width: 615px) {
    padding: 10px 20px;
    font-size: 14px;
  }
`

export const TinyButtonWhite = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 25px 0px;
  padding: 10px 30px;
  width: 300px;
  border-radius: 50px;
  font-weight: 700;
  color: ${ACTIVE_TEXT};
  font-size: 17px;
  outline: none;
  border: none;
  cursor: pointer;
  background: white;
  transition: all 200ms ease;
  :hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px ${TINY_SHADOW};
  }
  @media (max-width: 615px) {
    padding: 10px 20px;
    font-size: 14px;
  }
`

export const TinyButtonAlt = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 25px 0px;
  padding: 10px 30px;
  width: 200px;
  border-radius: 50px;
  font-weight: 700;
  color: ${ACTIVE_TEXT};
  font-size: 17px;
  outline: none;
  border: 2px solid ${ACTIVE_TEXT};
  cursor: pointer;
  background: white;
  transition: all 200ms ease;
  :hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px ${TINY_SHADOW};
  }
  @media (max-width: 615px) {
    padding: 10px 20px;
    font-size: 14px;
  }
`



// WEBPACK FOOTER //
// ./src/components/Button.js